// Application funnel URL — all "Apply" CTAs across the site link here.
export const APPLY_URL = 'https://api.leadconnectorhq.com/widget/form/DserJVKWV3KcncGfiXGa';